import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

$(window).on("load", function () {

  ScrollTrigger.create({
    trigger: '.topMv',
    ease: "power1",
    start: 'bottom top+=50px',
    endTrigger : '.body',
    end: 'bottom top',
    // markers: true,
    toggleClass: {
      targets: ".header.is-top",
      className: "is-on",
    },
    // once: true,
  });

  Array.prototype.slice.call(document.querySelectorAll('.js-trigger-fadeIn'),0).forEach(function(item) {
    gsap.from(
      item,
      {
        scrollTrigger: {
          trigger: item,
          start: '-20% 75%',
          toggleClass: 'is-on',
          once: true,
          // markers: true,
        },
      },
    );
  });

});
